export const Radius = {
    sm: '4px',
    md: '8px',
    lg: '12px',
    full: '50%',
}